import Vue from 'vue';
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'


import urlParam from 'url-param-object';
import FastClick from 'fastclick';

import { Wechat } from '@/utils';

import router from './router';
import store from './store';
import App from './App';
import config from './config.js';

import './assets/minishare-logo.png';
import './assets/wxshare-logo.png';

FastClick.attach(document.body);

Vue.config.productionTip = false;

Vue.use(ToastPlugin);
Vue.use(AjaxPlugin);

const { share } = config;

new Vue({
router,
store,
render: h => h(App),

methods: {
shareSuccess() {
this.$router.push({
path: 'shareSuccess',
});
},
setStoreData() {
const fromDevice = urlParam.getParamValue('openFrom') || '';
this.$store.dispatch('SET_FROM', {
openFrom: fromDevice,
isShowHeader: fromDevice === 'app',
});
this.$store.dispatch('SET_USERINFO', {
token: urlParam.getParamValue('token') || '',
deviceId: urlParam.getParamValue('deviceId') || '',
});
},
},
created() {
this.setStoreData();
},

mounted() {
Wechat.getAppId().then((data) => {
const resData = { ...data };
resData.title = share.title;
resData.desc = share.desc;
resData.link = share.linkUrl;
resData.imgUrl = share.imageWxUrl;
resData.onSuccess = this.shareSuccess;
Wechat.share(resData);
});
},
}).$mount('#app-box');



// WEBPACK FOOTER //
// ./src/pages/Application/main.js